<template>
    <div class="main">
        <el-header class="lg-header">
            <logo :logo="logo"/>
            <nav-menu class="menu"/>
            <el-row class="person-info">
                <el-col :span="6" class="set">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      {{$t('language')}}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="toggleLang('zh')" :disabled="$i18n.locale == 'zh'">中文</el-dropdown-item>
                      <el-dropdown-item @click.native="toggleLang('en')" :disabled="$i18n.locale == 'en'">English</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
                <el-col :span="18">
                    <el-dropdown @command="handleCommand">
                        <span class="person">
                            <i>{{$t('welcome_to_you')}}, </i>{{employee.name}} <i class="iconfont icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="enterpriseUuid">{{$t('company_number')}}</el-dropdown-item>
                            <el-dropdown-item command="quit">{{$t('safe_quit')}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </el-header>
        <el-main class="lg-main">
            <router-view class="main-container"></router-view>
        </el-main>

    </div>
</template>

<script>
    import Logo from '@/components/Logo'
    import NavMenu from '@/components/NavMenu'
    import {mapGetters, mapActions} from 'vuex'
    import {removeToken} from '@/util/auth'
    import {enterpriseLogo} from '@/api/account/enterprise'
    export default {
        name: '',
        components: {
            Logo,
            NavMenu
        },
        computed: {
            ...mapGetters(['employee'])
        },
        mounted: function () {
          console.log('enter')
          enterpriseLogo().then(res => {
            if (res.data !== ``) {
              this.logo = res.data
            }
          })
        },
        data: function () {
            return {
              logo :'http://img.dr-coffee.cn/logo.0e11affe.png'
            }
        },
        methods: {
            ...mapActions(['logout']),
            handleCommand(common) {
                switch (common) {
                    case 'quit':
                        removeToken()
                        this.logout()
                        this.$router.push({name: 'login'})
                        break;
                     case 'enterpriseUuid':

                       this.$alert(this.$t('company_number')+': '+this.employee.enterpriseUuid, this.$t('company_number'), {
                         confirmButtonText: this.$t('que_ding'),
                         callback: action => {
                         }
                       });

                }

            },
          toggleLang(lang) {
            if (lang == 'zh') {
              localStorage.setItem('locale', 'zh')
              this.$i18n.locale = localStorage.getItem('locale')
            } else if (lang == 'en') {
              localStorage.setItem('locale', 'en')
              this.$i18n.locale = localStorage.getItem('locale')
            }

            location.reload();
          },
        },
    }
</script>

<style lang="scss">
    .el-dropdown-menu {
        background-color: $bg_sec_color;
        .el-dropdown-menu__item {
            background-color: transparent !important;
            color: $f_sec_color;
        }
    }

    .el-dropdown-link {
      cursor: pointer;
      color: $f_color;
      border: 1px solid $f_color;
      padding: 1px 2px;
    }

    .main {
        height: 100%;
        width: 100%;
        background-color: $bg_color;
        display: flex;
        flex-direction: column;

        .lg-header {
            background-color: $bg_sec_color;
            height: $_header_height !important;
            display: flex;
            box-shadow: 0 1px 1px #262626;
            z-index: 9;
            .menu {
                flex: 1;
            }
            .person-info {
                justify-content: flex-end;
                width: 12.5rem;
                font-size: .8rem;
                text-align: end;
                .person, .set {
                    color: $f_sec_color;
                    height: $_header_height;
                    line-height: $_header_height;
                    cursor: pointer;
                }

                .set:hover {
                    color: $f_color;
                }

                .person {
                  margin-left: 6px;
                    i {
                        font-size: .7rem;
                    }
                }
            }
        }
        .lg-main {
            padding: $padding;
            display: flex;
            .main-container {
                flex: 1;
                -webkit-box-flex: 1;
            }
        }
    }
</style>
